(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-lus-launch]');
    if (!section) return;

    const target = new Date(section.dataset.launchAt).getTime();
    const fields = {
      days: section.querySelector('[data-days]'),
      hours: section.querySelector('[data-hours]'),
      minutes: section.querySelector('[data-minutes]'),
      seconds: section.querySelector('[data-seconds]')
    };
    let timer;

    const render = () => {
      const remaining = Math.max(0, target - Date.now());
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);

      fields.days.textContent = String(days).padStart(2, '0');
      fields.hours.textContent = String(hours).padStart(2, '0');
      fields.minutes.textContent = String(minutes).padStart(2, '0');
      fields.seconds.textContent = String(seconds).padStart(2, '0');

      if (remaining === 0 && timer) clearInterval(timer);
    };

    render();
    timer = setInterval(render, 1000);
  })();

  } catch(e) { console.error(e); }
})();
})();
